module.exports = __webpack_public_path__ + "static/media/left-arrow.0c51ec3e.svg";